import Index from './Index.vue';

export const routes = [
  {
    path: 'novidades',
    name: 'platform_announcements',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: Index,
  },
];
